import PropTypes from 'prop-types';
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';

import { Box, Divider } from '@mui/material';
import { MIcon } from '../../@material-extend';
import 'react-circular-progressbar/dist/styles.css';

const Countdown = ({ colors, counter, getColor }) => {
  let content = (
    <CircularProgressbar
      value={Math.floor(counter / 6)}
      strokeWidth={50}
      counterClockwise
      styles={buildStyles({
        pathColor: getColor() || colors.comete.light,
        trailColor: 'transparent',
        strokeLinecap: 'butt'
      })}
    />
  );

  if (!counter) {
    content = <MIcon icon="error" variant="critical" filled />;
  }

  return (
    <>
      <Box sx={{ flexShrink: 0, width: 24 }}>{content}</Box>
      <Divider sx={{ height: 28, mx: 1.5, borderWidth: 1 }} orientation="vertical" />
    </>
  );
};
Countdown.propTypes = {
  colors: PropTypes.object,
  counter: PropTypes.number,
  getColor: PropTypes.func
};

export default Countdown;
